import React from 'react';
import Bloc from '../components/Blocs/Bloc';
import { useTranslation } from 'react-i18next';
import { ContentWrapper, ContentBloc, TextLink } from '../styles/common';
import styled from 'styled-components';
import sfap from '../images/organizations/sfap.png';
import afsos from '../images/organizations/afsos.png';
import sfetd from '../images/organizations/sfetd.png';
import { ReactComponent as MailIcon } from '../images/mail.svg';

const PartnersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  a {
    margin: 0 10px;
    display: block;
    img {
      height: auto;
      width: 90px;
      mix-blend-mode: multiply;
    }
  }
  `;

const LinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 10px 0 0 0;
`;

const About = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <ContentBloc>
        <Bloc
          bgColor='#E5F8F4'
          color='#045F61'
          textSize='normal'>
          <h3>{t('aboutLeftTitle')}</h3>
          <PartnersWrapper>
            <a href="https://sfap.org/" target="_blank" rel="noreferrer"><img src={sfap} alt="SFAP"/></a>
            <a href="https://www.afsos.org/?lang=fr" target="_blank" rel="noreferrer"><img src={afsos} alt="AFSOS"/></a>
            <a href="https://www.sfetd-douleur.org/" target="_blank" rel="noreferrer"><img src={sfetd} alt="SFETD"/></a>
          </PartnersWrapper>
          <LinksWrapper>
            <TextLink href="/docs/docopioconvert.pdf" target="_blank" rel="noreferrer">{t('docLink')}</TextLink>
            <TextLink href="mailto:contact@opioconvert.fr"><MailIcon aria-hidden="true" />{t('contactLink')}</TextLink>
          </LinksWrapper>
        </Bloc>
        <Bloc
          bgColor='#E5F1F8'
          color='#0C2566'
          textSize='normal'>
          <h3>{t('oldVersionTitle')}</h3>
          <p>{t('oldVersionText')}</p>
          <TextLink href="https://v1.opioconvert.fr" target="_blank" rel="noreferrer">{t('oldVersionLink')}</TextLink>
        </Bloc>
      </ContentBloc>
      <ContentBloc>
        <Bloc
          bgColor='#E5F8F4'
          color='#045F61'
          textSize='normal'>
          <h3>{t('aboutRightTitle')}</h3>
          <p>{t('aboutRightText')}</p>
        </Bloc>
      </ContentBloc>
    </ContentWrapper>
  )
}

export default About